import {mapState} from "ui.vue3.vuex";

export const ButtonLoad = {
    computed: {
        ...mapState('itemsStore', ['currentPage', 'lastPage']),
    },
    methods: {
        load() {
            this.$store.dispatch('itemsStore/addCurrentPage');
            this.$store.dispatch('itemsStore/getItems');
        }
    },
    template: `<span v-if="(lastPage > currentPage)" class="btn btn-flex btn-solid-gray-lt news__btn" @click="load">{{ $Bitrix.Loc.getMessage('TITLE_ITEMS_LIST_BTN_LOAD_TEXT') }}</span>`
}